import PlaceholderPage from '@/pages/placeholder/page';

export default function CrmPage() {
  return (
    <PlaceholderPage
      title="Báo cáo CSKH"
      icon="ri-customer-service-2-line"
      description="Quản lý thông tin khách hàng: lịch sử tương tác, mua hàng, tồn kho đại lý, chương trình khuyến mãi và chăm sóc KH."
      phase={6}
    />
  );
}